// extracted by mini-css-extract-plugin
export default {"footlink":"index_footlink_dz3Df","fk_l":"index_fk_l_9cw1j","noBorder":"index_noBorder_-uXYO","copyright":"index_copyright_3tWrt"};